import * as React from 'react';

import classnames from 'classnames';

import styles from './sales-automation-card-email-wrapper.module.css';

type Props = {
    children?: React.ReactNode;
    isHidden: boolean;
    size: 'small' | 'medium' | 'large';
};

/*
 * Relatively positioned wrapper component that optionally takes children
 * to render. This is used for both "spacer" cards in the email automation
 * section, or to actually render rows.
 */
export class SalesAutomationCardEmailWrapper extends React.PureComponent<Props> {
    render() {
        const styleNames = classnames(styles['relative-container'], {
            [styles['relative-container--medium']]: this.props.size === 'medium',
            [styles['relative-container--tall']]: this.props.size === 'large',
        });

        return (
            <div
                style={{visibility: this.props.isHidden ? 'hidden' : 'inherit'}}
                className={styleNames}
            >
                {this.props.children}
            </div>
        );
    }
}
